import React from 'react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TextArea = styled.textarea<{
  placeholderTextColor?: React.CSSProperties['color'];
}>`
  padding: 8px 12px;
  height: 80px;
  border-radius: 4px;
  ::placeholder {
    ${({ placeholderTextColor }) =>
      placeholderTextColor ? { color: placeholderTextColor } : {}};
  }
`;

export const Label = styled.label`
  font-weight: bold;
`;
